export const LIGNE_ROB_SHOW_RESET = "LIGNE_ROB_SHOW_RESET";
export const LIGNE_ROB_SHOW_SET_ERROR = "LIGNE_ROB_SHOW_SET_ERROR";
export const LIGNE_ROB_SHOW_SET_RETRIEVED = "LIGNE_ROB_SHOW_SET_RETRIEVED";
export const LIGNE_ROB_SHOW_TOGGLE_LOADING = "LIGNE_ROB_SHOW_TOGGLE_LOADING";
